module.exports = __webpack_public_path__ + "media/components/country-flag/static/gi-74ee4ffd8439740171ae915ee460e6ae.svg";